import { UnstyledButton } from "@mantine/core";
import { Grid2x2, X } from "lucide-react";

import { Pill } from "../../../ui/Pill";
import classes from "./actions.module.css";
import type { ActionTool } from "./index";

export interface ActionsButtonProps {
  open: boolean;
  onToggle: () => void;
  /** The chosen action: its chip shows beside the pill, with an x that returns to the default. */
  chosen: ActionTool | null;
  onClear: () => void;
}

/**
 * Live's pill toolbar above the video composer: the "Actions" pill, which opens the panel, and
 * once an action is chosen its chip, "<icon> <Name> x" (captures 01 to 13).
 */
export function ActionsButton({ open, onToggle, chosen, onClear }: ActionsButtonProps) {
  const Icon = chosen?.icon;
  return (
    <div className={classes.toolbar}>
      <Pill
        label="Actions"
        icon={<Grid2x2 size={16} />}
        aria-expanded={open}
        aria-haspopup="dialog"
        onClick={onToggle}
      />
      {chosen === null || Icon === undefined ? null : (
        <span className={classes.chip}>
          <Icon size={16} aria-hidden />
          <span>{chosen.title}</span>
          <UnstyledButton
            className={classes.chipClear}
            aria-label={`Clear ${chosen.title}`}
            onClick={onClear}
          >
            <X size={14} strokeWidth={2} aria-hidden />
          </UnstyledButton>
        </span>
      )}
    </div>
  );
}
